<div class="m-1 d-inline-flex">
  <span class="font-weight-bold h5 mx-2">Sort By:</span>
  <select #sortBy (change)="sortBoardData(sortBy.value, sortDirection.value)" class="form-control w-auto pl-2">
    <option value="ownerName">Owner Name</option>
    <!-- <option value="projectManager">Project Manager</option> -->
  </select>
  <select
    (change)="sortBoardData(sortBy.value, sortDirection.value)"
    class="form-control w-auto pl-2 ml-1"
    #sortDirection>
    <option value="ASC">Asc</option>
    <option value="DESC">Desc</option>
  </select>
</div>
